import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sen-app-calculation-profitability',
  templateUrl: './calculation-profitability.component.html',
  styleUrls: ['./calculation-profitability.component.scss']
})
export class CalculationProfitabilityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
